var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('swiper',{staticClass:"hidden-xs-only",on:{"wow":_vm.wow}}),_c('smallSwiper',{staticClass:"hidden-sm-and-up",on:{"wow":_vm.wow}}),_c('about'),_c('strength'),_c('Product'),_c('Service'),_c('News')],1)}
var staticRenderFns = []

export { render, staticRenderFns }